import React, { Suspense } from "react";
import { Redirect, Switch /*, Route */ } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { HelpPage } from "./modules/Help";
import { FeedbackForm } from "./modules/CustomerFeedback";
import { CatalogueManagement } from "./modules/Catalogue";
import { PaymentManagement } from "./modules/Payment/pages/PaymentManagement";
import { ReceiptRetrievalManagement } from "./modules/ReceiptRetrieval/pages/ReceiptRetrievalManagement";

export default function BasePage() {

  return (
    <Suspense fallback={<LayoutSplashScreen />}>

      <Switch>
        {
          <Redirect exact from="/" to="/catalogue-management" />
        }
        <ContentRoute path="/payment-management" component={PaymentManagement} />
        <ContentRoute path="/customer-feedback" component={FeedbackForm} />
        <ContentRoute path="/catalogue-management/" component={CatalogueManagement} />
        <ContentRoute path="/receipt-retrieval" component={ReceiptRetrievalManagement} />
        <ContentRoute path="/help" component={HelpPage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
};
